/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Points_GpInputs */



/**
* | output |
* | --- |
* | "GP pts" |
*
* @param {League_Points_GpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_points_gp = /** @type {((inputs?: League_Points_GpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Points_GpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("pts GP")
	if (locale === "es") return /** @type {LocalizedString} */ ("pts GP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("pts GP")
	if (locale === "it") return /** @type {LocalizedString} */ ("pt GP")
	return /** @type {LocalizedString} */ ("GP pts")
});